import React, { useState } from 'react'
import classNames from 'classnames'
import IconChevron from 'components/partials/IconChevron'


function ContentToggle({ children, label, modifierContainerClasses = [], modifierButtonClasses = [], modifierLabelClasses = [], modifierContentClasses = [], toggled}) {

  const containerClasses = classNames(
    'content-toggle',
    'js-content-toggle',
    'rs_preserve',
    'content-toggle--reversed',
    modifierContainerClasses,
  )
  const buttonClasses = classNames(
    'content-toggle__button',
    toggled ? 'is-expanded' : '',
    modifierButtonClasses,
  )
  const labelClasses = classNames(
    'content-toggle__button-text',
    'u-mr-25',
    modifierLabelClasses,
  )
  const contentClasses = classNames(
    'content-toggle__content',
    'js-content-toggle__content',
    modifierContentClasses,
  )

  return (
    <div className={containerClasses}>
      <span
        className={buttonClasses}
        aria-haspopup="true"
        aria-expanded={toggled}
      >
        <span className={labelClasses}>{label}</span>
        <IconChevron />
      </span>
      {children ?
        <div className={contentClasses}>
          <p>{children}</p>
        </div> : ''}
    </div>)
}

export default ContentToggle
